export default {
  BlockPlacement__OPENS_NEW_WINDOW: "Opens new window",
};
